import React from 'react';
import { ModalButton } from 'helpers/getModals.styles';
import CategoryFilter from 'components/CategoryFilter/CategoryFilter';
import { CategoryPageModalProps } from 'models/CategoryPageModalProps';
import { FormattedMessage } from 'react-intl';
import { buildDropdownItems } from 'components/ShopResultListHeader/Sorting/Sorting.helpers';
import { defaultSorting } from 'components/ShopResultListHeader/Sorting/SortingValues';
import { buildHref } from './buildHref';
import {
  Context,
  Link,
  Button,
  Modal
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import styled from 'styled-components';

export const getModals = ({
  modalVisible,
  setModalVisible,
  categoryList,
  activeFilters,
  onParameterChange,
  translate
}: CategoryPageModalProps) => {
  const onResetCategorySelection = () => {
    const { pathname, query } = buildHref({
      ...activeFilters,
      category: undefined,
      page: undefined
    });

    onParameterChange({ pathname, query });
  };

  const categoryModalBottomElements = [];
  if (activeFilters.q && activeFilters.category) {
    categoryModalBottomElements.push(
      <Link key="Reset selection" onClick={onResetCategorySelection}>
        {translate('MODAL.RESET_SELECTION')}
      </Link>
    );
  }
  categoryModalBottomElements.push(
    <ModalButton
      key="Show results"
      type="button"
      onClick={/* istanbul ignore next */ () => setModalVisible(null)}
      context={Context.Primary}
      $context={Context.Primary}
    >
      <FormattedMessage id="MODAL.SHOW_RESULTS" tagName="span" />
    </ModalButton>
  );
  const currentSort = activeFilters.sort || defaultSorting;
  const CategoriesModal = styled(Modal)`
    && {
      padding: 0;
    }

    & > div:first-child {
      padding: 16px 24px;
    }
  `;

  return (
    <>
      <CategoriesModal
        open={modalVisible === 'categories'}
        setModal={setModalVisible}
        title={translate('CATEGORIES')}
        fixedBottomElements={categoryModalBottomElements}
        mobileElementType={'modal'}
      >
        {!!categoryList && categoryList.length > 0 && (
          <CategoryFilter
            categoryList={categoryList}
            activeFilters={activeFilters}
          />
        )}
      </CategoriesModal>
      <Modal
        open={modalVisible === 'sorting'}
        setModal={setModalVisible}
        title={translate('MODAL.SORTING.TITLE')}
        className={'sorting-area'}
        fixedBottomElements={[
          <Button
            key="Show results"
            type="button"
            onClick={/* istanbul ignore next */ () => setModalVisible(null)}
            $context={Context.Primary}
          >
            <FormattedMessage id="MODAL.SHOW_RESULTS" tagName="span" />
          </Button>
        ]}
      >
        {buildDropdownItems(currentSort, activeFilters, onParameterChange)}
      </Modal>
    </>
  );
};
